import { CATEGORIES_FETCH_SUCCESS } from "../actions/types";

const INIT_STATE = {
  categories: [],
};

export default (state = INIT_STATE, action = {}) => {
  switch (action.type) {
    case CATEGORIES_FETCH_SUCCESS: {
      return {
        ...state,
        categories: action.payload,
      };
    }
    default:
      return state;
  }
};
